import * as React from "react"
import { Footer, Header, Toast } from "components"
import { Container } from "reactstrap"
import { SocialStructuredData } from "components/seo"
const Template: React.FC = ({ children }) => {
	return (
		<>
			<Header />
			<Toast />
			<Container>{children}</Container>
			<SocialStructuredData />
			<Footer />
		</>
	)
}

export default Template
